import { supabase } from '../lib/supabase'
import type {
  ProcessN8nLog,
  ProcessN8nLogFilters,
  ProcessN8nLogListResult,
} from '../types/processN8nLogs'

export const processN8nLogsService = {
  async list(filters: ProcessN8nLogFilters = {}): Promise<ProcessN8nLogListResult> {
    const page = Math.max(1, filters.page ?? 1)
    const limit = Math.max(1, Math.min(100, filters.limit ?? 20))
    const from = (page - 1) * limit
    const to = from + limit - 1

    let query = supabase
      .from('process_n8n_logs')
      .select(
        'id, nome, execution_id, workflow_id, status, finished, mode, started_at, finished_at, created_at',
        { count: 'exact' }
      )
      .order('started_at', { ascending: false, nullsFirst: false })
      .range(from, to)

    if (filters.status && filters.status !== 'all') {
      query = query.eq('status', filters.status)
    }
    if (filters.nome?.trim()) {
      query = query.ilike('nome', `%${filters.nome.trim()}%`)
    }
    if (filters.dateFrom) {
      query = query.gte('started_at', `${filters.dateFrom}T00:00:00`)
    }
    if (filters.dateTo) {
      query = query.lte('started_at', `${filters.dateTo}T23:59:59.999`)
    }

    const { data, error, count } = await query
    if (error) throw error
    return {
      logs: (data ?? []) as ProcessN8nLog[],
      total: count ?? 0,
    }
  },

  async countErrors(filters: Pick<ProcessN8nLogFilters, 'dateFrom' | 'dateTo'> = {}): Promise<number> {
    let query = supabase
      .from('process_n8n_logs')
      .select('id', { count: 'exact', head: true })
      .in('status', ['error', 'failed', 'crashed'])

    if (filters.dateFrom) {
      query = query.gte('started_at', `${filters.dateFrom}T00:00:00`)
    }
    if (filters.dateTo) {
      query = query.lte('started_at', `${filters.dateTo}T23:59:59.999`)
    }

    const { count, error } = await query
    if (error) throw error
    return count ?? 0
  },
}
